import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { NavLink, Link } from 'react-router-dom'
import { Icon, Menu, Dropdown, } from 'antd'
import { logout as actionLogout } from '../../redux-flow/actions/login'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import theme from '../../config/theme'
import './navbar.css'
import profile from '../../images/profile.png'
const REACT_APP_NAME = process.env.REACT_APP_NAME


class Navbar extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            collapse: true,
            name: REACT_APP_NAME
        }
    }

    handleBurguer = () => {
        this.setState(oldState => ({
            collapse: !oldState.collapse
        }))
    }

    render() {
        const { collapse, name } = this.state
        const { fillBackground = true, logged, logout, userLogged, loggedArea } = this.props
        const menu = (
            <Menu>
                <Menu.Item key="1" className="dropMenuItem" style={{
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: theme.typography.fontSize.medium
                }}>
                    <NavLink to="/meusinvestimentos" className="navBtnSignup">Meus Investimentos</NavLink>
                </Menu.Item> 
                {/* <Menu.Item key="3" className="dropMenuItem" style={{
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: theme.typography.fontSize.medium
                }}>
                    <NavLink to="/wallet" className="navBtnSignup">Minha Wallet</NavLink>
                </Menu.Item>  */}
                <Menu.Item key="2" className="dropMenuItem" style={{
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: theme.typography.fontSize.medium
                }}>
                    <NavLink to="/minhaconta" className="navBtnSignup">Meus Dados</NavLink>
                </Menu.Item>
                <Menu.Item key="1" onClick={logout} className="dropMenuItem" style={{
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: theme.typography.fontSize.medium
                }}>
                    Sair
                </Menu.Item>
            </Menu>
        )
        return (
            <div className="section">
                <Container>
                    <Row>
                        <Col md={12}>
                            <nav className={`navbar ${fillBackground ? 'fillBackground' : ''} ${collapse ? 'collapsed' : ''} ${loggedArea ? 'loggedNav' : ''}`}>
                                <div className="navbarContentWrapper container d-flex">
                                    <div className="navbar-logo">
                                        <Link to="/"><img src={theme.logos.default} className="logoFlow" alt="logo_flow" /></Link>
                                    </div>
                                    <div className="admin-name">
                                        {name}
                                    </div>
                                    <div className="navbar-spacer" />
                                    <div className="navbar-items">
                                        <button onClick={this.handleBurguer} type="button" className="burguer-icon"><Icon type="bars" /></button>
                                        <ul>
                                            <li><a href="https://up365capital.com.br/#quem-somos" target="_blank" rel="noopener noreferrer">Inicio</a></li>
                                            <li><a href="https://up365capital.com.br/#quem-somos" target="_blank" rel="noopener noreferrer">Sobre<hr /></a></li>
                                            <li><a href="https://wa.me/5512992263753?text=Olá!%20Gostaria%20de%20solicitar%20atendimento%20!" target="_blank" rel="noopener noreferrer">Suporte<hr /></a></li>
                                            <div className={`nav-btns ${logged ? 'logado' : ''}`}>
                                                {logged ? (
                                                    <>
                                                    <li className="mobile"><NavLink to="/meusinvestimentos">Meus Investimentos<hr /></NavLink></li>
                                                    <li className="mobile"><NavLink to="/minhaconta">Meus Dados<hr /></NavLink></li>
                                                    <li className="mobile"><button onClick={logout} className="navBtnLogin">Sair</button></li>
                                                    {userLogged.fotoPerfil === null || userLogged.fotoPerfil === undefined || userLogged.fotoPerfil === '' ? 
                                                        <Dropdown.Button overlay={menu} className="dropdown-btn desktop" placement="bottomCenter">
                                                            <img src={profile} alt="Foto de perfil" className="fotoPerfil" />
                                                        </Dropdown.Button> : 
                                                        <Dropdown.Button overlay={menu} className="dropdown-btn desktop" placement="bottomCenter">
                                                            <img src={userLogged.url} alt="Foto de perfil" className="fotoPerfil" />
                                                        </Dropdown.Button>
                                                    }
                                                    </>
                                                ) : (
                                                    <>
                                                        <li><NavLink to="/cadastro" className="navBtnSignup">Abra sua conta</NavLink></li>
                                                        <li><NavLink to="/login" className="navBtnLogin">Entrar</NavLink></li>
                                                    </>
                                                )}
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
    logout: e => {
        // e.preventDefault()
        dispatch(actionLogout())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)